/**
 * 020 FR-020-010: a country is shown by its display name in the reader's locale, from
 * `Intl.DisplayNames`, never from a table of names kept in the client. The formatter is made once per
 * locale.
 */
const displayNames = new Map<string, Intl.DisplayNames>();

/** The country's name in `locale`, or the code itself where the platform has no name for it. */
export function countryName(locale: string, code: string): string {
  let names = displayNames.get(locale);
  if (names === undefined) {
    names = new Intl.DisplayNames([locale], { type: "region", fallback: "code" });
    displayNames.set(locale, names);
  }
  return names.of(code) ?? code;
}
